export default __webpack_public_path__ + "static/media/Lulu Logo.866137fb.png";